import { useMemo, useState } from "react";
import { GridLayout, HorizontalLayout, VerticalLayout } from "./layout";
import { TitleAtom } from "../atoms/titleAtom";
import { Search } from "../atoms/search";
import { FilterDropdown, IconButton, StandardButton } from "../atoms/buttons";
import { icon } from "../functions/icons";
import { TextAtom } from "../atoms/TextAtom";
import { PagePagination } from "../molecule/PagePagination";
import { renderCell } from "../functions/taskFunctions";


export function ReusableTable({ visible, itemClick, title="", useSearch = true, addLabel = "Toevoegen", onAdd, filterOptions = [], columns = [], rows = [], unitName = "leads", itemsPerPage = 8 }) {
    const [search, setSearch] = useState("");
    const [activeFilters, setActiveFilters] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const filteredRows = useMemo(() => {
        return rows.filter(row => {
            const matchesSearch = Object.values(row)
                .filter(v => typeof v === "string" || typeof v === "number")
                .join(" ")
                .toLowerCase()
                .includes(search.toLowerCase());
            const matchesFilter = activeFilters.length === 0 || activeFilters.includes(row.filterId);
            return matchesSearch && matchesFilter;
        });
    }, [search, activeFilters, rows]);

    const paginatedRows = filteredRows.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );
    const handleClick = (value) => {
        if (itemClick) {
            itemClick(value);
        }
    }
    console.log("filter", activeFilters, filteredRows);
    const rowLength = paginatedRows.length > itemsPerPage ? paginatedRows.length : itemsPerPage;
    if (!visible) {return <FallbackTable unitName={unitName}  />}
    return (
        <VerticalLayout className="card-background-color full-table-container" style={{ width: "auto"}}>
          <TableHead title={title} useSearch={useSearch} addLabel={addLabel} onAdd={onAdd} filterOptions={filterOptions} setSearch={setSearch} setActiveFilters={setActiveFilters} activeFilters={activeFilters} search={search} />
           <TableBody columns={columns} paginatedRows={paginatedRows} handleClick={handleClick} rowLength={rowLength} />
            <PagePagination
                currentPage={currentPage}
                totalUnits={filteredRows.length}
                onPageChange={setCurrentPage}
                unitName={unitName}
                itemsPerPage={itemsPerPage}
            />
        </VerticalLayout>
    );
}
const TableHead = ({ title, useSearch, addLabel, onAdd, filterOptions, setSearch, setActiveFilters, activeFilters, search }) => {
    const isMobile = window.innerWidth <= 768;
    return (
        <HorizontalLayout className="new-table-head space-between">
            <TitleAtom className={"medium-text"} title={title} />
            <HorizontalLayout style={{ alignItems: "center", gap: "1rem" }}>
                {useSearch && <Search className={"task-search"} onChange={setSearch} value={search} placeholder="Lead zoeken" />}
                {filterOptions?.length > 0 && (
                    <FilterDropdown options={filterOptions} selectedIds={activeFilters} onChange={setActiveFilters} />
                )}
                {onAdd && (
                    <StandardButton style={{ gap: ".5rem" }} className={"no-margin-left"} onClick={onAdd}>
                        {icon("plus", 20, "var(--white)")}
                        {!isMobile && addLabel}
                    </StandardButton>
                )}
            </HorizontalLayout>
        </HorizontalLayout>
    )
}
const TableBody = ({ columns, paginatedRows, handleClick, rowLength }) => {
    const isMobile = window.innerWidth <= 768;
    const FIXED_COLUMN_INDEX = 0;
    const [pageIndex, setPageIndex] = useState(0);
    const fixedColumn = columns[FIXED_COLUMN_INDEX];
    const scrollableColumns = columns.slice(1);
    const maxPage = scrollableColumns.length - 1;
    const visibleColumns = isMobile  ? [ fixedColumn, scrollableColumns[pageIndex] ] : columns;

    const handleNext = () => {
    if (pageIndex < maxPage) {
        setPageIndex(prev => prev + 1);
    }
    };

    const handlePrev = () => {
    if (pageIndex > 0) {
        setPageIndex(prev => prev - 1);
    }
    };

     return (
        <VerticalLayout className="table-container">
            {isMobile && (
                <HorizontalLayout className="table-header" style={{ justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                    <IconButton
                        icon2={pageIndex > 0 ? "chevron-left" : "minus"}
                        size={16}
                        className="table-scroll-indicator"
                        onClick={handlePrev}
                    />
                    <HorizontalLayout style={{ gap: "clamp(1rem, 20vw ,10rem)", width: "auto"}}>
                        {visibleColumns.map(col => (
                            <TextAtom key={col.key} title={col.label} />
                        ))}
                    </HorizontalLayout>
                    <IconButton
                        icon2={pageIndex < maxPage ? "chevron-right" : "minus"}
                        size={16}
                        className="table-scroll-indicator"
                        onClick={handleNext}
                    />
                </HorizontalLayout>
            )}
            {!isMobile && (
                <GridLayout columnsTemplate={`repeat(${columns.length}, 1fr)`} className="table-header center">
                    {columns.map(col => (
                        <TextAtom key={col.key} title={col.label} />
                    ))}
                </GridLayout>
            )}
            <GridLayout rowTemplate={`repeat(${rowLength}, 1fr)`} className="table-body">
                {paginatedRows.map((row, index) => (
                    <GridLayout
                        key={index}
                        onClick={() => handleClick(row)}
                        columnsTemplate={`repeat(${visibleColumns.length}, 1fr)`}
                        className={`${isMobile ? "space-between" : "center text-center"} table-row`}
                        style={{ padding: "1rem", alignItems: "center", }}
                    >
                        {visibleColumns.map(col => renderCell(row, col))}
                    </GridLayout>
                ))}
            </GridLayout>
        </VerticalLayout>
    );
};


const FallbackTable = ({unitName}) => {
    return (
        <HorizontalLayout className="card-background-color full-table-container standard-padding space-between" style={{ width: "auto"}}>
            <TitleAtom className={"medium-text"} title={`Gekoppelde ${unitName}`} />
            <TextAtom style={{ width: "100%", textAlign: "right" }} className={"standard-text-color-light small-text"} title={`Geen gekoppelde ${unitName} gevonden.`} />
        </HorizontalLayout>
    )
}
